<template>
	<div class="relative">
		<div class="bg-light-yellow fixed top-0 left-0 right-0 bottom-0 z-negative">
			<div class="fixed rounded-full light-purple-circle"></div>
			<div class="fixed rounded-full pink-circle"></div>
			<div class="fixed rounded-full purple-circle"></div>
			<div class="fixed rounded-full green-circle"></div>
			<div class="fixed rounded-full yellow-circle">
				<StripedCircle />
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
    import StripedCircle from "../StripedCircle";
	export default {
        name: "DefaultBackground",
		components: {StripedCircle}
	}
</script>

<style scoped>
	.light-purple-circle {
		width: 866px;
		height: 866px;
		background: #efe6f9;
		left: -610px;
		top: -500px;
	}

	.pink-circle {
		bottom: -272px;
		right: -272px;
		width: 564px;
		height: 564px;
		background: #fcad94;
	}

	.purple-circle {
		width: 54px;
		height: 54px;
		background: #de9ed2;
		right: 200px;
		bottom: 300px;
	}

	.yellow-circle {
		bottom: 120px;
		left: 120px;
	}

	.green-circle {
		width: 105px;
		height: 105px;
		background: #DDE9AC;
		left: 270px;
		top: 180px;
	}
</style>
